<div class="row">
    <div class="col-lg-3 col-md-3 col-6">
        <div class="single-funfact">
            <div class="icon">
                <i class='bx bxs-group'></i>
            </div>
            <h3><span [countUp]="staticks?.studentCount">{{staticks?.studentCount}}</span></h3>
            <p> {{"MENU.StudentCount" | translate}}    </p>
        </div>
    </div>
    <div class="col-lg-3 col-md-3 col-6">
        <div class="single-funfact">
            <div class="icon">
                <i class='bx bx-user-pin'></i>

            </div>
            <h3><span [countUp]="staticks?.teacherCount">{{staticks?.teacherCount}}</span></h3>
            <p> {{"MENU.TeachersCount" | translate}}    </p>
        </div>
    </div>
    <div class="col-lg-3 col-md-3 col-6">
        <div class="single-funfact">
            <div class="icon">
                <i class='bx bxl-deviantart'></i>
            </div>
            <h3><span [countUp]="staticks?.branchCount">{{staticks?.branchCount}}</span></h3>
            <p> {{"MENU.BranchesCount" | translate}}    </p>
        </div>
    </div>
    <div class="col-lg-3 col-md-3 col-6">
        <div class="single-funfact">
            <div class="icon">
                <i class='bx bx-book-reader'></i>

            </div>
            <h3><span [countUp]="staticks?.coursesCount">{{staticks?.coursesCount}}</span></h3>
            <p> {{"MENU.CoursesCount" | translate}}    </p>
        </div>
    </div>
</div>